"use client";

import { useI18n } from "@llmgateway/i18n/react";

import type { ReactNode } from "react";

interface LocalizedLegalContentProps {
	en: ReactNode;
	zhCN: ReactNode;
}

export function LocalizedLegalContent({
	en,
	zhCN,
}: LocalizedLegalContentProps) {
	const { locale } = useI18n();

	return <>{locale === "zh-CN" ? zhCN : en}</>;
}

export function LocalizedBackHomeText() {
	const { locale } = useI18n();

	return <>{locale === "zh-CN" ? "返回首页" : "Back home"}</>;
}
